<template>
    <div >
        <div class="panel panel-success"  >

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU USUÁRIO
            </div>
            <div class="panel-body" v-if="user.level < 3 && !user.permissoes.cacontrol" >
                <p>
                    <a :href="'#/cliente'" class="btn btn-info btn-block">NOVO USUÁRIO</a>
                </p>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
